import React from "react";
// import HttpService from '../utils/Http.services';
// import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Configurer from "../components/Configurer";
import StagesManager from "../components/StagesManager";
import { checkPermission, checkTranslation, pathMaker, translate } from "../utils/useful";
import PageStatusViewer from "../components/PageStatusViewer";
import AdminDashboard from "./admin/AdminDashboard";
import { adminPages, adminSections } from "../variables/adminPages";
import HomeDashboards from "./admin/HomeDashboards";
import AdminWidgetsPage from "./admin/AdminWidgetsPage";
import { test } from "../variables/adminWidgets";

class Admin extends React.Component {

    state = {
        modules: [],
        branches: [],
        collapses: {},
        pages: [
            { name: 'Dashboard', key: '', dontShowInDashboard: true },
        ],
        tabs: [
            // { pageHome: true, description: '{{lang}}Documents Records Platform', showInDashboard: true, title: '{{lang}}Documents Records', key: 'document', image: '/images/icons/records.png', page: 'document', defaultAccess: true },

            // { pageHome: true, description: '{{lang}}Energy Platform', showInDashboard: true, title: '{{lang}}Energy', key: 'energy', image: '/images/icons/booster.png', page: 'energy', defaultAccess: true, commingSoon: false },

            // { pageHome: true, description: '{{lang}}Carbon Platform', showInDashboard: true, title: '{{lang}}Carbon', key: 'carbon', image: '/images/icons/reduction.png', page: 'carbon', defaultAccess: true, commingSoon: false },

            { description: 'تنظیمات مدیریتی پلتفرم', showInDashboard: true, title: '{{lang}}Settings', key: 'settings', image: '/images/kheiry/settings-1.png', page: 'settings', defaultAccess: true, commingSoon: false },

        ],
        activeWidgets: 'adminPages',
    }


    componentDidMount() {

        this.props.setHeader({ title: '{{lang}}Dashboard' })
        // console.log('on home', this.props.myHeaders)
        // this.checkAdmin()
    }
    checkAdmin = (page) => {

        let path = pathMaker(page)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }
    componentDidUpdate(newProps) {
        let windowPath = this.props.location.pathname.split('/')
        windowPath = windowPath[windowPath.length - 1]

        // console.log(this.state.oldPath)
        // console.log(this.props.location.pathname)
        if (this.state.oldPath != this.props.location.pathname) {
            this.setState({ oldPath: this.props.location.pathname }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {

        let def = ''
        let pageType = null
        let pageInfo = null
        // console.log(window.location.pathname)
        let pathname = window.location.pathname.split('/')
        pathname.forEach((path, index) => {
            if (path == '/') {
                def = pathname[index + 1]
            }
        });

        // console.log(def)

        let pageIsValid = false

        Object.values(adminPages).forEach(page => {
            if (page.key.toLowerCase() === def?.toLowerCase()) {
                pageIsValid = true
                pageType = page.pageType
                // console.log(page)
                pageInfo = page
            }
        });
        if (!def || def == '' || checkPermission('admin.' + pageInfo.key) || !pageInfo || !pageInfo.permissionRules || (checkPermission(pageInfo.permissionRules))) {

            if (!def) {
                def = ''
            }
            // console.log(def)
            if (def === '') {
                pageType = ''
                pageIsValid = true
            }
            if (pageIsValid) {
                // this.state.page = page
                this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
                    this.setState({ path: def, }, () => {
                        this.stageManager.changeStage(pageType, () => {
                            window.scrollTo({ top: 0, behavior: 'smooth' })
                        })
                        setTimeout(() => {
                            this.setState({ page: null }, () => {

                                this.setState({ page: pageInfo })
                            })
                        }, 400);
                    })
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        } else {
            this.setState({ pageStatus: 401 })
        }

    }



    changePage = (page) => {

        let path = pathMaker(page)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }


    showMenu() {
        return (
            <div>
                <div className="text-center py-3">
                    <img src="/images/male.png" width="70px" style={{ borderRadius: 100 }} alt="" />
                    <p className="font-bold mt-1">{this.props.user?.info?.name} {this.props.user?.info?.family}</p>
                </div>


            </div>
        )
    }

    navigationBackButton(action) {
        return (
            <div className="flexc mx-2 h-100 d-md-none">
                <button className="p-0 m-0 flexcc h-100" onClick={() => this.mobileMenuModal.showModal()} style={{ backgroundColor: '#f2f6f8dd', color: '#334455', fontWeight: 'bold' }}>
                    <img className=" " src="/images/menu.png" alt="" width="30px" />
                </button>
            </div>
        )
    }

    informParent = (message) => {
        if (message == 'permissionDenied') {
            this.setState({ pageStatus: 401 })
        }
        if (message == 'notFound') {
            this.setState({ pageStatus: 404 })
        }
    }

    handlePlatformWidgets = (data) => {
        this.setState({ activeWidgets: data.key }, () => {
            // test(this.state.activeWidgets)
            console.log('this.state.activeWidgets', this.state.activeWidgets)
        })
    }

    render() {
        let admin = true
        let variables = {
            permissionRoot: 'admin.' + (this.state.page?.permissionParent ?? this.state.page?.key)
        }
        return (

            <Configurer
                settingsInfo={{
                    showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Admin", button: {},
                    titleButtons: [this.navigationBackButton(this.props.lastStage)]

                }}
                title={"Admin"}
                description={"Admin Description"}
                className="p-0 min-full-height w-100"
                ref={el => this.configurer = el}
                style={{ backgroundColor: '#f3f3f3' }}

            >

                <PageStatusViewer status={this.state.pageStatus}>
                    <div className="w-100 h-100" style={{ backgroundColor: '#f3f3f3' }}>
                        <div className="row m-0">
                            <div className="col-12 p-0" style={{}}>

                                <StagesManager ref={el => this.stageManager = el} fast={true}>

                                    <HomeDashboards admin={admin} activeWidgets={this.state.activeWidgets} handlePlatformWidgets={this.handlePlatformWidgets} pages={this.state.pages} stage={0} home={true} user={this.props.user} modules={this.state.tabs} stageName={''} changePage={this.changePage} title={'خیری 377'} description={translate("پلتفرم ارتباط با مشتریان ")} route={""} />
                                    <AdminWidgetsPage widget={this.state.activeWidgets} pages={this.state.pages} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={translate("")} description={translate("")} route={"admin"} />

                                </StagesManager>

                            </div>
                        </div>
                    </div>
                </PageStatusViewer>

            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Admin);
